import { getUnixTime } from "date-fns";
import TCreateEditNews from "types/News/createEditNews";

const newsItemMapper = (formValues: any): TCreateEditNews => ({
  title: formValues.title,
  date: getUnixTime(formValues.date),
  imageUrl:
    typeof formValues.imageUrl === "string" ? formValues.imageUrl : undefined,
  summary: formValues.summary,
  body: formValues.body,
  removeImageUrl: formValues.removeImageUrl,
});

export default newsItemMapper;
